import axios from 'axios'
import { OrganizationsListResponse } from 'src/models/organizations.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import { PostOrganizationRequest } from 'src/requests/postOrganization.request'
import { BackendErrorPayload } from 'src/utils/error.utils'

export interface PostOrganizationSuccessPayload {
  organization: OrganizationsListResponse
}

export const postCreateOrganization = async (
  body: Partial<PostOrganizationRequest>,
): Promise<PostOrganizationSuccessPayload> => {
  return getResponseData(
    axios.post<PostOrganizationSuccessPayload>(
      `/organizations`,
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

// Recovers err.response.data (or the normalized message) for legacy BackendErrorPayload consumers (src/queries/AGENTS.md).
export const recoverBackendErrorPayload = (
  errorSource: unknown,
): BackendErrorPayload<string> => {
  if (axios.isAxiosError(errorSource) && errorSource.response?.data) {
    return errorSource.response.data
  }
  if (
    errorSource !== null &&
    typeof errorSource === 'object' &&
    'error' in errorSource
  ) {
    return errorSource as BackendErrorPayload<string>
  }
  return { error: 'Sorry, something went wrong. Please try again later.' }
}
